export default __webpack_public_path__ + "static/media/mo-position-img-12@2x.b431aec0.png";